import React from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';

const TextInput = (props) => {
    return (
        <>
            <Input
                style={{ height: '40px', "textAlign": "left" }}
                {...props}
            >
            </Input>
            {Object.hasOwn(props, "touched") ? (props.touched && props.error && <Error>{props.error}</Error>) : <Error>{props.error}</Error>}
        </>
    )
}

export default React.memo(TextInput)